export const formStructureBuilder = (data) => {
  const structure = {};

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (
        value.length > 0 &&
        typeof value[0] === "object" &&
        value[0] !== null
      ) {
        structure[key] = {
          type: "arrayOfObjects",
          isArray: true,
          fields: Object.keys(value[0]),
          items: value,
        };
      } else {
        structure[key] = {
          type: "simpleArray",
          isArray: true,
          items: value,
        };
      }
    } else if (typeof value === "object" && value !== null) {
      structure[key] = {
        type: "object",
        isArray: false,
        value: value,
      };
    } else {
      structure[key] = {
        type: "text",
        isArray: false,
        value: value,
      };
    }
  });

  return structure;
};
